export const SEARCH_CAMPAIGNS_BY_RETAILER = 'SEARCH_CAMPAIGNS_BY_RETAILER'
export const SEARCH_CAMPAIGNS_BY_RETAILER_FULFILLED =
  'SEARCH_CAMPAIGNS_BY_RETAILER_FULFILLED'
export const SEARCH_CAMPAIGNS_BY_RETAILER_REJECTED =
  'SEARCH_CAMPAIGNS_BY_RETAILER_REJECTED'
/**
 * Retrieve campaigns by retailer with search criteria
 * @param {SearchCampaignsByRetailerPayload} payload
 * @returns {{payload: SearchCampaignsByRetailerPayload, type: string}}
 */
export const searchCampaignsByRetailer = (payload) => ({
  type: SEARCH_CAMPAIGNS_BY_RETAILER,
  payload,
})
